export default __webpack_public_path__ + "static/media/doc.b2039eb5.svg";